import { create } from "zustand";

export const useWalletStore = create((set) => ({
  isWalletActive: null,
  isPayViaWallet: false,
  topupModalOpen: false,
  withdrawalModalOpen: false,
  automatedPayoutModalOpen: false,
  automatedPayoutToggle: false,
  automatedTopupModalOpen: false,
  automatedTopupToggle: false,
  settlementViewDetailsModalOpen: false,
  settlementViewDetailModalRecord: {},
  minBalanceToggle: false,
  minBalanceValue: null,
  automatePayoutToggle: false,
  automatedPayoutFormDate: {},
  setIsWalletActive: (val) => set({ isWalletActive: val }),
  setIsPayViaWallet: (val) => set({ isPayViaWallet: val }),
  isTopupModalOpen: (val) => set({ topupModalOpen: val }),
  isWithdrawalModalOpen: (val) => set({ withdrawalModalOpen: val }),
  isAutomatedPayoutModalOpen: (val) => set({ automatedPayoutModalOpen: val }),
  isAutomatedPayoutToggle: (val) => set({ automatedPayoutToggle: val }),
  isautomatedTopupModalOpen: (val) => set({ automatedTopupModalOpen: val }),
  isAutomatedTopupToggle: (val) => set({ automatedTopupToggle: val }),
  isSettlementViewDetailsModalOpen: (val) =>
    set({ settlementViewDetailsModalOpen: val }),
  setSettlementViewDetailModalRecord: (val) =>
    set({ settlementViewDetailModalRecord: val }),
  setMinBalanceToggle: (val) => set({ minBalanceToggle: val }),
  setMinBalanceValue: (val) => set({ minBalanceValue: val }),
  setAutomatePayoutToggle: (val) => set({ automatePayoutToggle: val }),
  initailizeAutomatedPayoutFormDate: (val) =>
    set({ automatedPayoutFormDate: val }),
  setAutomatePayoutFormData: (key, val) =>
    set((state) => ({
      automatedPayoutFormDate: { ...state.automatedPayoutFormDate, [key]: val },
    })),
  handleStoreValChange: (key, val) => set({ [key]: val }),
  handleStoreBatchChange: (batchSet) => set({ ...batchSet }),
}));
